<template>
  <div class="about-school-section grid grid-cols-2 gap-5 max-lg:grid-cols-1">
    <div class="w-full overflow-hidden">
      <Swiper
        class="relative z-0 rounded-[24px]"
        :modules="[Navigation]"
        :navigation="{
          prevEl: '.btn-prev',
          nextEl: '.btn-next',
        }"
      >
        <SwiperSlide
          v-for="(img, index) in images || []"
          :key="index"
          class="relative h-100! max-lg:h-85! max-md:h-60!"
        >
          <img
            class="rounded-[24px] max-md:rounded-[16px] w-full h-full object-cover object-top"
            :src="`${img}?random=${index + 1}`"
            alt="Фото школы"
          />
          <div class="text-white absolute bottom-5 left-5">
            Моковое изображение
          </div>
        </SwiperSlide>

        <div class="absolute bottom-5 right-5 z-1 flex gap-3">
          <UButton
            class="btn-prev"
            color="white"
            variant="outline"
            size="lg"
            icon="i-local-chevron-left"
          />
          <UButton
            class="btn-next"
            color="white"
            variant="outline"
            size="lg"
            icon="i-local-chevron-right"
          />
        </div>
      </Swiper>
    </div>

    <div class="w-full py-11 pl-10 max-lg:pl-0 max-lg:pt-4 max-lg:pb-0">
      <h2 class="typo-heading-h2 mb-4">О нашей школе</h2>
      <div
        class="typo-paragraph-md-regular text-content-default-secondary mb-12"
        v-html="description"
      />

      <UButton class="max-md:w-full" @click="signForClass">Записаться</UButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import 'swiper/css'
import 'swiper/css/navigation'

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper/modules'
import SignForClassModal from '~/components/SignForClassModal.vue'
import { useModal } from '~/shared/modals'

defineOptions({
  name: 'AboutSchoolSection',
})

defineProps<{
  description?: string
  images?: string[]
}>()

const { routeId } = useRouteId()

const signForClass = () => {
  const { open } = useModal(SignForClassModal, {
    props: {
      id: routeId,
      apiMethod: useSchoolStore().trainingSignup,
    },
  })

  open()
}
</script>

<style lang="scss" scoped></style>
